export default __webpack_public_path__ + "static/media/ROX_4892.70d0cea6.jpg";